import { render, staticRenderFns } from "./applyForm.vue?vue&type=template&id=6bd81bc6&scoped=true&"
import script from "./applyForm.vue?vue&type=script&lang=js&"
export * from "./applyForm.vue?vue&type=script&lang=js&"
import style0 from "./applyForm.vue?vue&type=style&index=0&id=6bd81bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd81bc6",
  null
  
)

export default component.exports